import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import SubAbasUser from './SubAbasUser';
import BarraInferiorBotoes from '../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../components/BarraSubAbas';
import BoxConteudo from '../../../components/BoxConteudo';
import ContainerConteudo from '../../../components/ContainerConteudo';
import CustomCol from '../../../components/CustomCol';
import CustomInputMask from '../../../components/CustomInputs/CustomInputMask';
import CustomInputText from '../../../components/CustomInputs/CustomInputText';
import CustomRow from '../../../components/CustomRow';
import CustomSelect from '../../../components/CustomSelects/CustomSelect';
import Input from '../../../components/InputNew';
import Select from '../../../components/InputNew/Select';
import StyledLink from '../../../components/Link';
import Modal from '../../../components/Modal';
import SubAbas from '../../../components/SubAbas';
import VinculoUsuarioListagem from '../../../components/VinculoUsuario/listagem';
import WorkspaceBotoes from '../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../components/WorkspaceFicha';
import { usePasswordValidation } from '../../../modules/hooks/usePasswordValidation';
import { useCor } from '../../../services/enum/useCorPele';
import { useGeneros } from '../../../services/enum/useGeneros';
import { useOrgaoOrigem } from '../../../services/enum/useOrgaoOrigem';
import { useTipoVinculo } from '../../../services/enum/useTipoVinculo';
import httpClient from '../../../services/httpClient';
import { getUserData } from '../../../services/userService';
import { useUserIdData } from '../../../services/usuario/useUserIdData';
import { getToken } from '../../../utils/functions';
import { swal, swalAttention, swalAtualizacao } from '../../../utils/swal';

const FichaUsuario: React.FC = () => {
  // Parâmetro da URL
  const { id } = useParams<{ id?: string }>();
  const params = useParams();
  const fichaID = String(params.id);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, setError] = useState<string | null>(null);
  // Dados do usuário e estado do formulário
  const { formData, setFormData } = useUserIdData();

  // Controle de visibilidade dos modais
  const [showModal, setShowModal] = useState<boolean>(false);

  // Funções para alternar modais
  const handleModal = () => setShowModal((prev) => !prev);

  // Títulos e ícones dos modais
  const tituloModal = 'Alterar Senha';
  const iconeModal = 'key';

  // Hook para obter dados
  const generos = useGeneros();
  const cores = useCor();
  const orgaoOrigem = useOrgaoOrigem();
  const tipoVinculo = useTipoVinculo();

  const [userRole, setUserRole] = useState<number | null>(null); // Papel do usuário

  useEffect(() => {
    const fetchUserRoleAndUnit = async () => {
      try {
        const token = await getToken();
        const decodedToken: any = jwtDecode(token);
        const { papel, unidade } = decodedToken;

        if (Array.isArray(papel) && papel.length > 0) {
          setUserRole(papel[0]);
        } else {
          setError('Papel do usuário não encontrado no token.');
        }

        if (unidade) {
          setFormData((prev) => ({
            ...prev,
            unidadeCadastro: unidade,
          }));
        } else {
          setError('Unidade do usuário não encontrada no token.');
        }
      } catch (error) {
        setError('Erro ao obter papel ou unidade do usuário');
      }
    };

    fetchUserRoleAndUnit();
  }, []);

  //SENHA -  validar a senha do usuário
  const [senha, setSenha] = useState<string>('');
  const [confirmaSenha, setConfirmaSenha] = useState<string>('');

  const [validLength, passwordMatch] = usePasswordValidation({
    firstPassword: senha,
    secondPassword: confirmaSenha,
  });

  const [passwordDigits, setPasswordDigits] = useState<number>(0);

  const validaSenhaTamanho = () => {
    if (passwordDigits > 0 && !validLength) {
      swal(
        'error',
        'Senha inválida',
        'A senha deve conter no mínimo 6 caracteres!',
      );
      setSenha('');
      handleModal();
    }
  };

  const validaSenhaConfirma = () => {
    if (passwordDigits >= 6 && !passwordMatch) {
      swal('error', 'Senha inválida', 'As senhas digitadas não são iguais!');
      setConfirmaSenha('');
      handleModal();
    }
  };
  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;

    const enumFields = [
      'genero',
      'cor',
      'tipoVinculo',
      'orgaoOrigem',
      'unidadeCadastro',
      'papelUsuario',
      'moduloUsuario',
    ];

    const newValue = enumFields.includes(name)
      ? value
        ? Number(value)
        : 0
      : value;

    setFormData((prev) => {
      const updatedForm = {
        ...prev,
        [name]: newValue,
      };

      // Quando tipoVinculo for "Consultor Técnico", limpa campos relacionados
      if (name === 'tipoVinculo' && ['1'].includes(String(newValue))) {
        updatedForm.orgaoOrigem = '0';
        updatedForm.outroOrgao = '';
      }

      return updatedForm;
    });
  };

  // Validação
  const validateForm = (form: any) => {
    const errors: string[] = [];

    if (form.tipoVinculo === '0' || !form.tipoVinculo) {
      errors.push('O campo <b>Tipo de vínculo</b> é obrigatório.');
    }

    if (Number(form.tipoVinculo) > 1 && Number(form.orgaoOrigem) === 0) {
      errors.push(
        'Órgão de <b>Origem</b> é obrigatório para o tipo de vínculo selecionado.',
      );
    }

    if (Number(form.orgaoOrigem) === 6 && !form.outroOrgao) {
      if (form.outroOrgao === '') {
        errors.push(
          'Informe o campo <b>Outro órgão</b> quando o órgão de origem for "Outro".',
        );
      }
    }

    if (form.emailPessoal) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(form.emailPessoal)) {
        errors.push('O campo <b>EMAIL</b> deve conter um email válido.');
      }
    } else {
      errors.push('O campo <b>EMAIL</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>'));
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleSenhaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSenha(e.target.value);
    setPasswordDigits(e.target.value.length);
  };

  const handleConfirmaSenhaChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setConfirmaSenha(e.target.value);
  };
  const fetchData = async () => {
    try {
      const userData = await getUserData(id?.toString() || '0');
      setFormData(userData);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id, setFormData]);

  //UPDATE USER
  const updateData = async () => {
    const validateFormResult = validateForm(formData);

    if (!validateFormResult) {
      return;
    }

    try {
      // Normaliza os dados para envio
      const sanitizedData = {
        ...formData,
        emailInstitucional: formData.emailPessoal,
        tipoVinculo: Number(formData.tipoVinculo) ?? 0,
        orgaoOrigem: formData.orgaoOrigem ? Number(formData.orgaoOrigem) : 0,
        outroOrgao: formData.outroOrgao || '',
      };

      const response = await httpClient.patch(
        `/api/users/${id}`,
        sanitizedData,
      );

      swalAtualizacao('Sucesso', response.data.message);
      // setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      console.error('Erro ao atualizar dados:', error);
      swal(
        'error',
        'Algo deu errado... Alterações não foram realizadas com sucesso. Tente novamente.',
        'error',
      );
    }
  };

  //UPDATE SENHA
  const updateSenha = async () => {
    try {
      if (!validLength || !passwordMatch)
        throw new Error(
          'As senhas devem ter no mínimo 6 caracteres e serem iguais.',
        );

      const response = await httpClient.patch(`/api/users/${id}/senha`, {
        novaSenha: senha,
      });

      if (response.status === 200) {
        setShowModal(false);
        setSenha('');
        setConfirmaSenha('');
        swalAtualizacao('Sucesso', response.data.message);
      } else {
        throw new Error('Erro ao atualizar senha');
      }
    } catch (error) {
      console.error('Erro ao alterar senha:', error);
      swal(
        'error',
        'Erro ao alterar senha',
        'As senhas devem ter no mínimo 6 caracteres e serem iguais.',
      );
    }
  };

  let subAbas;
  if (fichaID !== 'undefined') {
    subAbas = SubAbasUser(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: '#',
      },
    ];
  }

  ///
  const [statusStyleUsuario, setStatusStyleUsuario] =
    useState<React.CSSProperties>({});

  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';

    setStatusStyleUsuario({
      backgroundColor: formData.stRegistroAtivo === 'S' ? verde : vermelho,
    });
  }, [formData.stRegistroAtivo]);

  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/adm/usuarios"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <span className="material-icons">arrow_back</span>
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>
      <ContainerConteudo>
        <WorkspaceFicha>
          {/* Dados do Usuário */}
          <BoxConteudo boxTitulo="Dados do Usuário">
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol
                width="200px"
                helpText={
                  formData.stRegistroAtivo === 'S'
                    ? 'Usuário POSSUI VÍNCULO ativo.'
                    : 'Usuário NÃO POSSUI VÍNCULO ativo.'
                }
              >
                <CustomInputText
                  name="stRegistroAtivo"
                  value={formData.stRegistroAtivo === 'S' ? 'Ativo' : 'Inativo'}
                  title="Status"
                  onChange={handleChange}
                  style={statusStyleUsuario}
                  readOnly
                />
              </CustomCol>
              <CustomCol width="180px">
                <CustomInputMask
                  name="cpf"
                  mask="999.999.999-99"
                  value={formData.cpf}
                  id="cpf"
                  title="CPF"
                  onChange={handleChange}
                  readOnly
                />
              </CustomCol>
              <CustomCol>
                <CustomInputText
                  name="nomeCompleto"
                  value={formData.nomeCompleto || ''}
                  id="nome"
                  title="Nome completo"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="200px">
                <CustomInputText
                  name="dataNascimento"
                  value={formData.dataNascimento}
                  id="dataNascimento"
                  title="Data de nascimento"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="200px">
                <CustomSelect
                  name="genero"
                  value={formData.genero ? formData.genero.toString() : ''}
                  onChange={handleChange}
                  options={generos}
                  title="Gênero"
                />
              </CustomCol>
              <CustomCol width="200px">
                <CustomSelect
                  name="cor"
                  value={formData.cor ? formData.cor.toString() : ''}
                  onChange={handleChange}
                  options={cores}
                  title="Cor da pele"
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="200px">
                <CustomInputMask
                  name="celular"
                  mask="(99) 99999-9999"
                  value={formData.celular}
                  id="celular"
                  title="Celular"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="180px">
                <CustomInputMask
                  name="ramal"
                  mask="9999"
                  value={formData.ramal}
                  id="ramal"
                  title="Ramal"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="220px">
                <CustomSelect
                  name="tipoVinculo"
                  value={formData.tipoVinculo?.toString() || ''}
                  onChange={handleChange}
                  options={tipoVinculo}
                  title="Vínculo funcional"
                  required
                />
              </CustomCol>

              <CustomCol width="380px">
                <CustomSelect
                  name="orgaoOrigem"
                  value={formData.orgaoOrigem}
                  options={orgaoOrigem}
                  title="Orgão de origem"
                  onChange={handleChange}
                  disabled={['0', '1'].includes(String(formData.tipoVinculo))}
                  required={Number(formData.tipoVinculo) > 1}
                />
              </CustomCol>

              <CustomCol>
                <CustomInputText
                  name="outroOrgao"
                  value={formData.outroOrgao}
                  id="outroOrgao"
                  title="Outro órgão"
                  onChange={handleChange}
                  readOnly={!['6'].includes(String(formData.orgaoOrigem))}
                  required={Number(formData.orgaoOrigem) === 6}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <CustomInputText
                  name="emailPessoal"
                  value={formData.emailPessoal}
                  id="emailPessoal"
                  title="Email"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              {/* <CustomCol>
                <Input
                  name="emailInstitucional"
                  value={formData.emailInstitucional}
                  id="emailInstitucional"
                  label="Email institucional"
                  onChange={handleChange}
                />
              </CustomCol> */}
              <CustomCol>
                <CustomInputText
                  name="linkedin"
                  value={formData.linkedin}
                  id="linkedin"
                  title="LinkedIn"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol>
                <CustomInputText
                  name="lattes"
                  value={formData.lattes}
                  id="lattes"
                  title="Lattes"
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {/* Identificação da Vinculação */}
          <VinculoUsuarioListagem fichaID={fichaID} onRefreshData={fetchData} />

          {/* Modal de alteração de senha */}
          <Modal
            icone={iconeModal}
            tituloModal={tituloModal}
            open={showModal}
            onHide={handleModal}
            modalSize="medio"
          >
            <div className="d-flex form flex-column justify-content-center align-items-center gap-4 m-3">
              <Input
                name="senha"
                id="senha"
                value={senha}
                label="Nova Senha"
                onChange={handleSenhaChange}
                onBlur={validaSenhaTamanho}
                type="password"
              />
              <Input
                name="confirmaSenha"
                value={confirmaSenha}
                label="Confirma Senha"
                id="confirmaSenha"
                onChange={handleConfirmaSenhaChange}
                type="password"
                onBlur={validaSenhaConfirma}
              />
              <WorkspaceBotoes save onClickSave={updateSenha} />
            </div>
          </Modal>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          save
          onClickSave={updateData}
          senha
          onClickSenha={handleModal}
        />
      </BarraInferiorBotoes>
    </>
  );
};
export default FichaUsuario;
